import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
const TranscriberProvider = lazy(()=> import(/* webpackChunkName: "Voice Provider" */'./components'));

const routes = () => (
    <PrivateRoute exact path="/settings/transcriber-provider" component={TranscriberProvider} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/TranscriberProvider/routes.js